module.exports = __webpack_public_path__ + "imageIconlogo.png?816381ffb847519c96337ba67a00b599";